/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import * as R from 'ramda';
import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import { createPopper } from '@cian/popper-fork';
export function usePopper(props) {
  var open = props.open,
      anchorRef = props.anchorRef;

  var _ref = props.options || {},
      placement = _ref.placement,
      modifiers = _ref.modifiers,
      strategy = _ref.strategy,
      onFirstUpdate = _ref.onFirstUpdate;

  var instanceRef = React.useRef(null);
  var popperRef = React.useRef(null);
  var instance = instanceRef.current;
  var state = instance && instance.state;
  var options = React.useMemo(function () {
    return R.filter(function (v) {
      return v !== undefined;
    }, {
      placement: placement,
      modifiers: modifiers,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate
    });
  }, [modifiers, onFirstUpdate, placement, strategy]);
  React.useEffect(function () {
    if (!open) {
      return;
    }

    return function () {
      if (instanceRef.current) {
        instanceRef.current.destroy();
        instanceRef.current = null;
      }
    };
  }, [open]);
  var tryOpen = React.useCallback(function () {
    var popperEl = popperRef.current;
    var anchorEl = anchorRef.current;

    if (!open || !anchorEl || !popperEl) {
      return;
    }

    if (instanceRef.current) {
      instanceRef.current.destroy();
      instanceRef.current = null;
    }

    instanceRef.current = createPopper(anchorEl, popperEl, options);
  }, [anchorRef, open, options]);
  var handleRef = React.useCallback(function (node) {
    popperRef.current = node;
    tryOpen();
  }, [tryOpen]);
  useIsomorphicLayoutEffect(function () {
    // Обновление позиции, на случай если компонент сместился
    if (instanceRef.current) {
      instanceRef.current.forceUpdate();
    }
  });
  return {
    ref: handleRef,
    attributes: state && state.attributes.popper,
    style: state && state.styles.popper
  };
}